import type { BackorderRow } from '@eombor/contracts';
import { t } from '../../../shared/i18n/index.js';
import type { BackorderSelection } from '../model/selection.js';

/**
 * BELGILASH KATAKCHASI — uch xil ro'yxatda bir xil.
 *
 * Jadval, guruh va kartochka uchta alohida fayl, lekin katakchaning
 * xulqi bitta: mos kelmaydigan qatorda o'chadi va nomi ekran o'quvchiga
 * QAYSI bildirgi ekanini aytadi. Uch nusxada yozilsa, ulardan biri bir
 * kun `disabled` ni unutib, mos kelmaydigan arizani belgilashga yo'l
 * qo'yardi.
 */
export const PickBox = ({
  row,
  selection,
}: {
  row: BackorderRow;
  selection: BackorderSelection;
}) => {
  const picked = selection.has(row);
  const allowed = picked || selection.canPick(row);

  return (
    <input
      type="checkbox"
      checked={picked}
      disabled={!allowed}
      onChange={() => selection.toggle(row)}
      aria-label={t('backorder.pickOne', { docNo: row.docNo })}
      className="size-4 shrink-0 accent-[var(--color-accent)] disabled:opacity-30"
    />
  );
};
